import { useEffect, useState/*, useRef*/ } from 'react';
//import { BottomNavigation, BottomNavigationAction} from '@material-ui/core';
import { BottomNavigation, BottomNavigationAction} from '@mui/material';
import { useNavigate } from 'react-router';

const FooterMenu = ({ current = 0, ...props }) => {
    //const history = useHistory();
    const navigate = useNavigate();

    const [value, setValue] = useState(current);
  
    useEffect(() => {}, []);
  
    const handleClick = (val) => {
        if (val === value)
            return;
        
        switch (value) {
            case 0:
                //history.push({path:"/alerts"});
                navigate('/alert');
                break;
            case 1:
                //history.push({path:"/checks"});
                navigate('/check');
                break;
            case 2:
                //history.push({path:"/errors"});
                navigate('/error');
                break;
            case 3:
                //history.push({path:"/resources"});
                navigate('resource');
                break;
            default:
        }
    };
  
  
    return (
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction
          label="Alarm"
          icon={<i class="material-icons">notifications</i>}
          onClick={handleClick(0)}
        />
        <BottomNavigationAction
          label="Check"
          icon={<i class="material-icons">assignment_turned_in</i>}
          onClick={handleClick(1)}
        />
        <BottomNavigationAction
          label="Error"
          icon={<i class="material-icons">error</i>}
          onClick={handleClick(2)}
        />
        <BottomNavigationAction
          label="Resource"
          icon={<i class="material-icons">library_books</i>}
          onClick={handleClick(3)}
        />
      </BottomNavigation>
    );
};

export default FooterMenu;
